export const docType = [
  {
    name: 'HOLERITE',
    value: 'hole'
  },
  {
    name: 'ATESTADO',
    value: 'ates'
  },
  {
    name: 'DOCUMENTO',
    value: 'doc'
  },
  {
    name: 'RELATÓRIO',
    value: 'relato'
  }
]

export const afastamentoType = [
  {
    name: 'NÃO INFORMADO',
    value: 'não informado'
  },
  {
    name: 'ATROPELAMENTO',
    value: 'atropelamento'
  },
  {
    name: 'COLISÃO',
    value: 'colisão'
  },
  {
    name: 'OUTROS',
    value: 'outros'
  }
]

// class Lookups {
//   addCurrentValue (value) {
//     const currentPeriod = {
//       label: `Periodo atual: ${value} dias`,
//       value: Number(value)
//     }
//     periodicityField[6] = currentPeriod

//     return periodicityField
//   }
// }

export default { docType, afastamentoType }
